import { useMemo } from 'react';
import type { Slide } from '@/api/cms';
import { NativeSlider } from '@/components/NativeSlider';
import {
  SliderArrow,
  type SliderWithInsideArrows,
} from '@/components/NativeSlider/helpers';
import { useMatchingSections } from '@/modules/restrictions/hooks/useAccessSections';
import { useGetCommonStore } from '@/store';
import { type IPromotionProps, Promotion } from './Promotion';
import { ScSliderContainer } from './styled';

interface PromotionsSliderProps {
  promoSlides: Slide[];
}

export const PromotionsSlider: React.FC<PromotionsSliderProps> = ({
  promoSlides,
}) => {
  const slides = useMatchingSections(promoSlides);
  const useCommonStore = useGetCommonStore();
  const isMobileDevice = useCommonStore.use.isMobileDevice();

  const sliderProps = useMemo(() => {
    const arrows: SliderWithInsideArrows | undefined = isMobileDevice
      ? undefined
      : {
          type: SliderArrow.INSIDE,
        };

    return {
      loop: true,
      pagination: true,
      arrows,
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
      },
    };
  }, [isMobileDevice]);

  const slidesWithImageProps = useMemo<IPromotionProps[]>(
    () =>
      slides.map((slide, index) => ({
        ...slide,
        loading: index === 0 ? 'eager' : 'lazy',
      })),
    [slides]
  );

  return (
    <ScSliderContainer>
      {slides.length ? (
        <NativeSlider<IPromotionProps>
          slide={Promotion}
          slides={slidesWithImageProps}
          {...sliderProps}
        />
      ) : null}
    </ScSliderContainer>
  );
};

export default PromotionsSlider;
